var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoShareGray({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0.587891C8.10169 0.587891 8.19866 0.60813 8.28709 0.6448C8.37555 0.6814 8.45842 0.735653 8.53033 0.807561L12.4421 4.71933C12.735 5.01222 12.735 5.48709 12.4421 5.77999C12.1492 6.07288 11.6743 6.07288 11.3814 5.77999L8.75 3.14855V9.16142C8.75 9.57563 8.41421 9.91142 8 9.91142C7.58579 9.91142 7.25 9.57563 7.25 9.16142V3.14855L4.61857 5.77999C4.32567 6.07288 3.8508 6.07288 3.55791 5.77999C3.26501 5.48709 3.26501 5.01222 3.55791 4.71933L7.46967 0.807561C7.54158 0.735653 7.62445 0.6814 7.71291 0.6448C7.80134 0.60813 7.89831 0.587891 8 0.587891ZM2.25 9.49966C2.25 9.08544 1.91421 8.74966 1.5 8.74966C1.08579 8.74966 0.75 9.08544 0.75 9.49966V14.4997C0.75 14.9139 1.08579 15.2497 1.5 15.2497H14.5C14.9142 15.2497 15.25 14.9139 15.25 14.4997V9.49966C15.25 9.08544 14.9142 8.74966 14.5 8.74966C14.0858 8.74966 13.75 9.08544 13.75 9.49966V13.7497H2.25V9.49966Z",
    fill: "#646566"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoShareGray);
export default __webpack_public_path__ + "static/media/ico_share_gray.76c53c819d5752fbb1e71346f3039b49.svg";
export { ForwardRef as ReactComponent };